import { render } from "./SupplyFavPage.vue?vue&type=template&id=0cd45a1a"
import script from "./SupplyFavPage.vue?vue&type=script&lang=js"
export * from "./SupplyFavPage.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__